<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_number`)" :subHeader="$t('headers.general.watch_profile')" class="watch-profile-number-form">
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-select v-model="model.data.type_id" :options="options" name="ssnumber_type" :placeholder="$t('labels.general.type')" rules="required"/>
			<input-text v-model="model.data.number" name="ssnumber_number" :placeholder="$t('labels.general.number')" rules="required"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			model: new ApiObject(),
			form: {
				loading: false,
				error: ''
			},
			options: []
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addSSNumber()
					break
				case 'edit':
					this.editSSNumber()
					break
				default:
					this.$log.warn('watch profile ssnumber form', 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getSSNumberNames () {
			this.$api.profile.ssnumbers.getNames(this)
				.then(response => {
					this.$log.info('watch profile ssnumber form', 'profile.ssnumbers.getNames OK', response)()
					this.options = []
					response.body.forEach(element => {
						this.options.push({ value: element.id, text: this.$t('labels.numbers.'+element.type.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) })
					})
				}).catch(error => {
					this.$log.error('watch profile ssnumber form', 'profile.ssnumbers.getNames ERROR', error)()
					this.error = error
				})
		},
		getSSNumber () {
			this.model.loading = true
			this.$api.profile.ssnumbers.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info('watch profile ssnumber form', 'profile.ssnumbers.get OK', response)()
					this.model.data = response.body
				}).catch(error => {
					this.$log.error('watch profile ssnumber form', 'profile.ssnumbers.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addSSNumber () {
			this.form.loading = true
			this.$api.profile.ssnumbers.add(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile ssnumber form', 'profile.ssnumbers.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile ssnumber form', 'profile.ssnumbers.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editSSNumber () {
			this.form.loading = true
			this.$api.profile.ssnumbers.edit(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile ssnumber form', 'profile.ssnumbers.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile ssnumber form', 'profile.ssnumbers.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		}
	},
	created () {
		this.getSSNumberNames()
		switch (this.params.action) {
			case 'add':
				this.model.data = {
					type_id: '',
					number: ''
				}
				break
			case 'edit':
				this.getSSNumber()
				break
			default:
				this.$log.warn('watch profile ssnumber form', 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/profile/SSNumberForm.vue